const MODULE_NAME = 'visszahivasKeresService';
class VisszahivasKeresService {
	constructor($http) {
		'ngInject';
		this.$http = $http;
		this.apiRoot = '/api/';
	}
	getVisszahivasKeresInit() {
		return this.$http.get(`${this.apiRoot}visszahivas/init`);
	}
	sendVisszahivas(emailObject) {
		let objectToPost = Object.assign({}, emailObject);
		let captchaValue = objectToPost.captchaValue;
		delete objectToPost.captchaValue;
		return this.$http({
			url: `${this.apiRoot}visszahivas/`,
			method: 'POST',
			headers: {
				'captcha': captchaValue
			},
			data: objectToPost
		});
	}
}

export default angular.module(MODULE_NAME, []).service('visszahivasKeresService', VisszahivasKeresService).name;



// WEBPACK FOOTER //
// ../source/application/services/visszahivas-keres.js